module.exports = __webpack_public_path__ + "img/all-selected.fd16c980.svg";